import { useSyncExternalStore } from "react"

type WsStatus = "connecting" | "connected" | "disconnected"

let status: WsStatus = "disconnected"
const listeners = new Set<() => void>()

function notify() {
  for (const fn of listeners) fn()
}

export function setWsStatus(next: WsStatus) {
  if (status === next) return
  status = next
  notify()
}

export function useWsStatus(): WsStatus {
  return useSyncExternalStore(
    (cb) => { listeners.add(cb); return () => listeners.delete(cb) },
    () => status,
  )
}
